export default "__VITE_ASSET__DlmC0HHd__"